class ZoStickyPurchasePanel extends HTMLElement {
  #closeButton;
  #scrollContainer;
  #scrollTimer;
  #frame;

  connectedCallback() {
    this.#closeButton = this.querySelector('[data-zo-sticky-close]');
    this.handleClose = this.handleClose.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.#closeButton?.addEventListener('click', this.handleClose);
    this.#scrollContainer = this.#getScrollContainer();
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });
    this.#scrollContainer?.addEventListener('scroll', this.handleScroll, { passive: true });
    this.addEventListener('scroll', this.handleScroll, { passive: true });
    this.dataset.stickyDismissed = 'false';
    this.#updateStickyState();
  }

  disconnectedCallback() {
    this.#closeButton?.removeEventListener('click', this.handleClose);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    this.#scrollContainer?.removeEventListener('scroll', this.handleScroll);
    this.removeEventListener('scroll', this.handleScroll);
    window.clearTimeout(this.#scrollTimer);
    window.cancelAnimationFrame(this.#frame);
  }

  handleClose() {
    this.dataset.stickyDismissed = 'true';
    this.dataset.stickyActive = 'false';
    this.dataset.scrollActive = 'false';
  }

  handleScroll() {
    if (this.dataset.stickyDismissed === 'true') return;

    this.dataset.scrollActive = 'true';
    window.clearTimeout(this.#scrollTimer);
    this.#scrollTimer = window.setTimeout(() => {
      this.dataset.scrollActive = 'false';
      this.#updateStickyState();
    }, 180);

    window.cancelAnimationFrame(this.#frame);
    this.#frame = window.requestAnimationFrame(() => this.#updateStickyState());
  }

  handleResize() {
    this.#scrollContainer?.removeEventListener('scroll', this.handleScroll);
    this.#scrollContainer = this.#getScrollContainer();
    this.#scrollContainer?.addEventListener('scroll', this.handleScroll, { passive: true });
    this.#updateStickyState();
  }

  #getScrollContainer() {
    let ancestor = this.parentElement;

    while (ancestor) {
      const overflowY = window.getComputedStyle(ancestor).overflowY;
      const canScroll = /(auto|scroll|overlay)/.test(overflowY) && ancestor.scrollHeight > ancestor.clientHeight;
      if (canScroll) return ancestor;
      ancestor = ancestor.parentElement;
    }

    return document.scrollingElement;
  }

  #updateStickyState() {
    if (this.dataset.stickyDismissed === 'true' || !window.matchMedia('(min-width: 750px)').matches) {
      this.dataset.stickyActive = 'false';
      return;
    }

    const rect = this.getBoundingClientRect();
    const parentRect = this.parentElement?.getBoundingClientRect();
    const stickyTop = Number.parseFloat(window.getComputedStyle(this).top) || 0;
    const atStickyTop = Math.abs(rect.top - stickyTop) <= 2;
    const hasRoomBelow = !parentRect || parentRect.bottom > stickyTop + 48;
    const scrollPosition = this.#scrollContainer?.scrollTop ?? window.scrollY;
    this.dataset.stickyActive = String(atStickyTop && hasRoomBelow && scrollPosition > 0);
  }
}

if (!customElements.get('zo-sticky-purchase-panel')) {
  customElements.define('zo-sticky-purchase-panel', ZoStickyPurchasePanel);
}
